import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '@app/services/toast.service';
import { AuthServiceService } from '@app/services/auth-service.service';
import { ChatbotService } from '@app/services/chatbot.service';
import { environment } from '@environments/environment';
interface MenuItem {
  icon: string;
  label: string;
  route: string;
  badge?: number;
  subItems?: { label: string; route: string; icon?: string }[];
}
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Input() isCollapsed = false;
  @Output() toggleSidebar = new EventEmitter<void>();

  @ViewChild('navMenu') navMenu!: ElementRef;
  @ViewChild('flyoutList') flyoutList!: ElementRef;

  private isSyncing = false;

  onNavScroll(event: Event): void {
    if (this.isSyncing) return;
    this.isSyncing = true;
    if (this.flyoutList) {
      this.flyoutList.nativeElement.scrollTop = (event.target as HTMLElement).scrollTop;
    }
    this.isSyncing = false;
  }

  onFlyoutScroll(event: Event): void {
    if (this.isSyncing) return;
    this.isSyncing = true;
    if (this.navMenu) {
      this.navMenu.nativeElement.scrollTop = (event.target as HTMLElement).scrollTop;
    }
    this.isSyncing = false;
  }
  // badge: 14
  shippingMenuItems: MenuItem[] = [
    {
      icon: 'package',
      label: 'Orders',
      route: '/admin/dashboard',
      subItems: [
        { label: 'Dashboard', route: '/admin/dashboard', icon: 'home' },
        { label: 'Order List', route: '/admin/orders', icon: 'package' },
        { label: 'Add Order', route: '/admin/orders/add', icon: 'plus' },
        { label: 'Archive', route: '/admin/archive-orders', icon: 'archive' }
      ]
    },
    {
      icon: 'bulk',
      label: 'Bulk Orders',
      route: '/admin/bulk-order',
      subItems: [
        { label: 'Add Bulk Order', route: '/admin/bulk-order', icon: 'plus' }
      ]
    },
    {
      icon: 'warehouse',
      label: 'Warehouses',
      route: '/admin/warehouse',
      subItems: [
        { label: 'List Warehouses', route: '/admin/warehouse', icon: 'list' },
        { label: 'Add Warehouse', route: '/admin/warehouse/add', icon: 'plus' }
      ]
    },
    {
      icon: 'users',
      label: 'Drivers',
      route: '/admin/driver',
      subItems: [
        { label: 'List Drivers', route: '/admin/driver', icon: 'list' },
        { label: 'Add Driver', route: '/admin/driver/add', icon: 'plus' },
        { label: 'Locate Drivers', route: '/admin/locate-driver', icon: 'map' }
      ]
    },
    { icon: 'notifications', label: 'Notifications', route: '/admin/send-notification' },
    {
      icon: 'address',
      label: 'Addresses',
      route: '/admin/address',
      subItems: [
        { label: 'List Addresses', route: '/admin/address', icon: 'list' },
        { label: 'Add Address', route: '/admin/address/add', icon: 'plus' }
      ]
    },
    { icon: 'companies', label: 'Companies', route: '/admin/companies' },
    {
      icon: 'ticket',
      label: 'Tickets',
      route: '/admin/ticket',
      subItems: [
        { label: 'List Tickets', route: '/admin/ticket', icon: 'list' },
        { label: 'Create Ticket', route: '/admin/ticket/create-ticket', icon: 'plus' }
      ]
    },
    { icon: 'user', label: 'Profile', route: '/admin/profile' },
    { icon: 'package', label: 'Archive Orders', route: '/admin/archive-orders' },
    { icon: 'analytics', label: 'Analytics', route: '/admin/analytics' },
    { icon: 'settings', label: 'Settings', route: '/admin/setting' }
  ];

  receivingMenuItems: MenuItem[] = [
    {
      icon: 'package',
      label: 'Orders',
      route: '/receiving-admin/orders',
      subItems: [
        { label: 'Order List', route: '/receiving-admin/orders', icon: 'list' }
      ]
    },
    {
      icon: 'ticket',
      label: 'Tickets',
      route: '/receiving-admin/ticket',
      subItems: [
        { label: 'List Tickets', route: '/receiving-admin/ticket', icon: 'list' },
        { label: 'Create Ticket', route: '/receiving-admin/ticket/create-ticket', icon: 'plus' }
      ]
    },
    { icon: 'settings', label: 'Settings', route: '/receiving-admin/setting' },
    { icon: 'ai', label: 'Ask RTT AI', route: '#' },
    { icon: 'map', label: 'Locate Drivers', route: '/receiving-admin/locate-driver' }
  ];

  isShippedAdmin = localStorage.getItem('is_shipped_admin') === 'true';
  isReceivingAdmin = localStorage.getItem('is_receiving_admin') === 'true';

  get menuItems(): MenuItem[] {
    if (this.router.url.startsWith('/receiving-admin')) {
      return this.receivingMenuItems;
    }
    return this.shippingMenuItems;
  }
  logoUrl: any
  companyName: string = localStorage.getItem('org_name') || localStorage.getItem('compname') || 'RealTimeTrac';
  companyAddress: string = localStorage.getItem('organizationaddress') || 'Delivery System';
  adminName: string = localStorage.getItem('name') || 'Admin User';
  appVersion: string = `v${environment.appVersion}`;

  constructor(public router: Router, private toast: ToastService, private authService: AuthServiceService, private chatbotService: ChatbotService) {
    const storedLogoUrl = localStorage.getItem('logo'); // Replace 'logo' with your actual local storage key

    // Check if storedLogoUrl is valid (not null, 'null', or empty)
    if (storedLogoUrl && storedLogoUrl.trim() !== '' && storedLogoUrl.trim().toLowerCase() !== 'null') {
      this.logoUrl = storedLogoUrl; // Use the stored logo URL if valid
    } else {
      // Fallback to default logo
      this.logoUrl = 'assets/images/Logo.png';
    }
  }

  ngOnInit() {
    if (!this.authService.getToken) return;
    this.authService.getProfile().subscribe((data: any) => {
      if (data?.result?.organization) {
        const roleId = parseInt(localStorage.getItem('role')?.split(',')[0] || '0');
        const id = roleId === 1 ? data?.result?.id : data?.result?.admin?.id;
        localStorage.setItem('notifId', id);
        if (roleId === 2) {
          localStorage.setItem('is_superuser', data.result.admin.is_superuser);
          localStorage.setItem('is_staff', data.result.admin.is_staff);
          localStorage.setItem('logo', data.result.organization.company.logo);
          localStorage.setItem('require_delivery_signature', data.result.organization.company.require_delivery_signature);
          localStorage.setItem('organizationaddress', data.result.warehouse.address.address);
        }
        const org = data.result.organization;
        // Check both top-level and nested company structure
        const name = org.name || org.company?.name;
        if (name) {
          this.companyName = name;
          localStorage.setItem('org_name', name);
        }

        // Handle address which could be an object, a string, or nested in company
        const orgAddress = org.address || org.company?.address;
        if (orgAddress) {
          const addressStr = (typeof orgAddress === 'object' ? orgAddress?.address : orgAddress);
          if (addressStr) {
            this.companyAddress = addressStr;
            localStorage.setItem('org_address', addressStr);
          }
        }

        const logo = org.logo || org.company?.logo;
        if (logo) {
          this.logoUrl = logo;
          localStorage.setItem('logo', logo);
        }
      }
      if (data.result?.warehouse?.address) {
        const warehouseAddress = data.result.warehouse.address.address;
        this.companyAddress = warehouseAddress;
        localStorage.setItem('organizationaddress', warehouseAddress);
      }
      // Identify where the user details exist in the profile response
      if (data?.result) {
        const source = data.result.admin || data.result.user || data.result;
        if (source.first_name && source.last_name) {
          this.adminName = `${source.first_name} ${source.last_name}`;
          localStorage.setItem('name', this.adminName);
        } else if (source.first_name) {
          this.adminName = source.first_name;
          localStorage.setItem('name', this.adminName);
        }
      }
    });
  }

  isActiveRoute(route: string): boolean {
    return this.router.url === route;
  }

  isFlyoutClosedOnClick = false;

  onMenuItemClick(event: Event, item: MenuItem): void {
    if (this.isCollapsed) {
      this.isFlyoutClosedOnClick = true;
    }

    if (item.icon === 'ai') {
      event.preventDefault();
      this.chatbotService.toggleChatbotVisibility();
    }
  }

  resetFlyout(): void {
    this.isFlyoutClosedOnClick = false;
  }

  onToggle(): void {
    this.isFlyoutClosedOnClick = false; // Reset on toggle too
    this.toggleSidebar.emit();
  }

  switchDashboard(event: any): void {
    localStorage.setItem('isroleChanged', 'false');
    const value = event.target.value;
    const isShippedAdmin = localStorage.getItem('is_shipped_admin') === 'true';
    const isReceivingAdmin = localStorage.getItem('is_receiving_admin') === 'true';

    if (value === 'shipping' && isShippedAdmin) {
      this.router.navigate(['/admin/dashboard']);
      this.authService.setLS('role', [2, 'Organization Admin']);
      this.authService.getRole();
    } else if (value === 'shipping' && !isShippedAdmin) {
      this.toast.show('warning', 'You do not have access to the Shipping Dashboard');
      event.target.value = 'receiving';
    } else if (value === 'receiving' && isReceivingAdmin) {
      this.router.navigate(['/receiving-admin/orders']);
      this.authService.setLS('role', [3, 'Customer']);
      this.authService.getRole();
    } else if (value === 'receiving' && !isReceivingAdmin) {
      this.toast.show('warning', 'You do not have access to the Receiving Dashboard');
      event.target.value = 'shipping';
    }
  }

  getCurrentDashboard(): string {
    return this.router.url.startsWith('/receiving-admin') ? 'receiving' : 'shipping';
  }
  logout() {
    this.authService.doLogout();
  }
  showLogoutPopup = false;

  openLogout() {
    this.showLogoutPopup = true;
  }

  closeLogout() {
    this.showLogoutPopup = false;
  }

  confirmLogout() {
    this.authService.doLogout();
  }

  getAdminInitials(): string {
    if (!this.adminName || this.adminName === 'Admin User') return 'AD';
    const parts = this.adminName.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    }
    return parts[0].charAt(0).toUpperCase();
  }
}
